import { HomeItemV2, HomeListOptionV2, HomeListRequestDto } from '../../../../types/home/list';
import { HomesFindAllResponseBodyHomeDto } from '../../../../types/api/homes';
import { TableListData } from '../../../../types/common/table';
import { homeApiV2 } from '../../../../lib/api/home/homeApiV2';
import { HOME_TAB_STATUS_TYPE_V2, HOME_TYPE_V2 } from '../../../../constants/service/app/homeConstantsV2';

export const subHomeListOptionConverter = {
  clientToServer: (option: HomeListOptionV2): HomeListRequestDto => ({
    page: option.page,
    pageSize: option.pageSize,
    title: option.title,
    memo: option.memo,
    id: option.id,
    type: HOME_TYPE_V2.SUB,
    status: HOME_TAB_STATUS_TYPE_V2.ACTIVE,
  }),
};

export const homeConverter = {
  serverToClient: (home: HomesFindAllResponseBodyHomeDto): HomeItemV2 => ({
    id: home.id,
    type: home.type,
    title: home.title,
    memo: home.memo,
    status: home.status,
    createDate: home.createDate,
    updateDate: home.updateDate,
  }),
};

export const subHomeListFetcher = async (option: HomeListOptionV2): Promise<TableListData<HomeItemV2>> => {
  const result = await homeApiV2.getHomeList(subHomeListOptionConverter.clientToServer(option));

  return {
    totalCount: result.totalCount,
    list: result.homes.map((home) => homeConverter.serverToClient(home)),
  };
};
